import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LogoutButton extends Vue {
  /**
   * Redirect the participant identificatioon
   */
  protected logout(): void {
    this.$store.dispatch('setHasGivenUp', true).then(() => {
        this.$router.push({
            name: 'atHomeConfirmation',
            params: {
            screening: this.$route.params.screening
            },
        });
    });
  }
}
